import { toBackend } from '@utils/map-date/to-backend';
import moment from 'moment';

export const formatWeeklyValidityToBackend = ({
  weekDays,
  fromValidity,
  untilValidity,
  timezone,
}: {
  weekDays?: {
    id: string;
    name: string;
    checked: boolean;
  }[];
  fromValidity?: moment.Moment | null;
  untilValidity?: moment.Moment | null;
  timezone: string;
}) => {
  const weekDaysSelected = weekDays?.filter((day) => day.checked).map((day) => day.id);
  const openingTime = moment(fromValidity).startOf('day').tz(timezone);
  const closingTime = moment(untilValidity).endOf('day').tz(timezone);

  return {
    ...(fromValidity && { from: toBackend(openingTime) }),
    ...(untilValidity && { until: toBackend(closingTime) }),
    ...(weekDays && { passDayValidity: weekDaysSelected }),
  };
};
